import { render } from "./settingsComponent.vue?vue&type=template&id=7cd2d59c&scoped=true"
import script from "./settingsComponent.vue?vue&type=script&lang=js"
export * from "./settingsComponent.vue?vue&type=script&lang=js"

import "./settingsComponent.vue?vue&type=style&index=0&id=7cd2d59c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd2d59c"]])

export default __exports__